import pick from 'lodash/pick'
import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find'

import { parseLocation, makeLink } from '../utils/urlHelper'
import canonicalUrlAttributes from '../constants/canonicalUrlAttributes'
import siteConfigTopLevelCategories from '../../config/sites/categories'

const getTagFromPath = (path) => {
  return path.split('/')[2]
}

const isTagAlsoACategory = (currentSite, tag) => {
  const siteRootCategories = siteConfigTopLevelCategories[currentSite]

  return !isEmpty(find(siteRootCategories, { path: tag }))
}

const isTagOnlySearch = (path) => {
  return path.indexOf('/tags/') === 0
}

const isLandingPage = (location) => {
  return location.pathname.indexOf('/free/') === 0
}

const buildCanonicalPath = (currentSite, location) => {
  if (isLandingPage(location)) {
    return buildCanonicalPathForLandingPage(location)
  } else {
    return buildCanonicalPathForSearch(currentSite, location)
  }
}

const buildCanonicalPathForLandingPage = (location) => {
  return location.pathname
}

const buildCanonicalPathForSearch = (currentSite, location) => {
  const parsedLocation = parseLocation(location)
  let filteredCanonicalQueries = pick(parsedLocation, canonicalUrlAttributes)
  if (filteredCanonicalQueries.page && filteredCanonicalQueries.page.toString() === '1') {
    delete filteredCanonicalQueries.page
  }
  let canonicalPath = makeLink(filteredCanonicalQueries)

  let actualPath = location.pathname
  if (isTagOnlySearch(actualPath)) {
    const tag = getTagFromPath(actualPath)
    if (isTagAlsoACategory(currentSite, tag)) {
      canonicalPath = canonicalPath.replace('tags', 'category')
    }
  }
  return canonicalPath
}

export default buildCanonicalPath



// WEBPACK FOOTER //
// ./common/utils/buildCanonicalPath.js